import { useEffect } from "react";

import {
  MAXX_PLAYBACK_REQUEST_EVENT,
  normalizeMaxxPlaybackAction,
} from "./playbackController";
import { recordLiveAppInteraction } from "../../world-model/liveAppPerception";

export function useMaxxVoiceRegistry({
  enabled = true,
  actions,
  onPause,
  onResume,
  logPrefix = "[VoiceModel]",
  registerMessage = "Registered n2x voice handler",
  unregisterMessage = "Unregistered n2x voice handler",
}) {
  useEffect(() => {
    if (!enabled || !actions) return undefined;

    const pauseModel = (metadata = {}) => {
      Object.values(actions).forEach((action) => {
        if (!action) return;
        action.paused = true;
      });
      onPause?.(metadata);
    };

    const resumeModel = (metadata = {}) => {
      Object.values(actions).forEach((action) => {
        if (!action) return;
        action.paused = false;
        if (!action.isRunning()) action.play();
      });
      onResume?.(metadata);
    };

    const handler = (action, metadata = { source: "voice" }) => {
      console.log(`🎬 ${logPrefix} n2x.glb → ${action}`);
      const normalizedAction = normalizeMaxxPlaybackAction(action);
      if (metadata?.source === "voice" && normalizedAction) {
        recordLiveAppInteraction(
          normalizedAction === "pause" ? "pause_neurons" : "resume_neurons",
          "maxx_neurons",
          { portal: "maxx" }
        );
      }
      if (normalizedAction === "pause") pauseModel(metadata);
      if (normalizedAction === "resume") resumeModel(metadata);
    };

    const handlePlaybackRequest = (event) => {
      handler(event.detail?.action, {
        source: event.detail?.source || "interface",
      });
    };

    window.__voiceModelRegistry = window.__voiceModelRegistry || {};
    window.__voiceModelRegistry.n2x = (action) => handler(action, { source: "voice" });
    window.addEventListener(MAXX_PLAYBACK_REQUEST_EVENT, handlePlaybackRequest);
    console.log(`🎧 ${registerMessage}`);

    return () => {
      window.removeEventListener(MAXX_PLAYBACK_REQUEST_EVENT, handlePlaybackRequest);
      if (window.__voiceModelRegistry) {
        delete window.__voiceModelRegistry.n2x;
      }
      console.log(`🧹 ${unregisterMessage}`);
    };
  }, [
    actions,
    enabled,
    logPrefix,
    onPause,
    onResume,
    registerMessage,
    unregisterMessage,
  ]);
}
